import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardContent } from "@material-ui/core";
// import ApexChart from "react-apexcharts";
import { getActiveReminders } from "../../../../../service/dashboardServices";

const RemindersCard = () => {
  const history = useHistory();
  const [activeReminders, setActiveReminders] = useState(0);

  const fetchActiveReminders = () => {
    getActiveReminders()
      .then((res: any) => {
        setActiveReminders(res.data.total);
      })
      .catch((err) => {});
  };

  // const options = {
  //   chart: {
  //     // type: "line",
  //     width: 100,
  //     height: 35,
  //     sparkline: {
  //       enabled: true,
  //     },
  //   },
  //   tooltip: {
  //     fixed: {
  //       enabled: false,
  //     },
  //     x: {
  //       show: false,
  //     },
  //     y: {
  //       title: {
  //         formatter: function(seriesName) {
  //           return "";
  //         },
  //       },
  //     },
  //   },
  // };

  useEffect(() => {
    fetchActiveReminders();
    // eslint-disable-next-line
  }, []);
  return (
    <Card>
      <CardContent className="p-5">
        <b
          className="m-0 text-uppercase cursor-pointer"
          onClick={() => {
            history.push("/message");
          }}
        >
          Active Reminders&nbsp;&nbsp;
          <i style={{ color: "#000" }} className="fa fa-chevron-right"></i>
        </b>
        <div className="d-flex justify-content-between mt-3">
          <h2 className="m-0 font-weight-light">{activeReminders || 0}</h2>
          <div style={{ width: 150 }}>
            {/* <ApexChart
              options={options}
              series={[
                {
                  data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54],
                },
              ]}
              type="bar"
              height={35}
            /> */}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RemindersCard;
